import { Provider } from '@angular/core';
import {
  NUCLEUS_AUDIT_REPORT_FILENAME,
  NUCLEUS_AUDIT_SERVICE,
} from '@nucleus/audit-report-ui';

import { TasksenseAuditServiceAdapter } from './tasksense-audit.adapter';

export * from './tasksense-audit.adapter';

/**
 * Provider list for @nucleus/audit-report-ui's contract tokens.
 * Register in the module hosting <lib-audit-report> (ReportsModule).
 *
 * NUC-294: the audit-report lib gates on AuditCaps codes via the shared
 * CAPABILITY_CHECKER (wired app-wide to PermissionsService); the old
 * NUCLEUS_AUDIT_PERMISSIONS seam was removed in @nucleus/audit-report-ui 0.0.39.
 */
export const NUCLEUS_AUDIT_UI_PROVIDERS: Provider[] = [
  { provide: NUCLEUS_AUDIT_SERVICE,         useExisting: TasksenseAuditServiceAdapter },
  { provide: NUCLEUS_AUDIT_REPORT_FILENAME, useValue: 'tasksense-audit-report' },
];
